import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["subject", "body"]
  static outlets = ["dialog", "template-variables"]

  prepare(event) {
    this.field = event.params.field === "subject" ? this.subjectTarget : this.bodyTarget
    this.selectionStart = this.field.selectionStart
    this.selectionEnd = this.field.selectionEnd
    this.templateVariablesOutlet.reset(event.params.field)
  }

  insert(event) {
    if (!this.field) return

    this.field.setRangeText(event.detail.source, this.selectionStart, this.selectionEnd, "end")
    this.selectionStart = this.field.selectionStart
    this.selectionEnd = this.field.selectionEnd
    this.field.dispatchEvent(new Event("input", { bubbles: true }))
    this.dialogOutlet.close()
  }

  restoreFocus() {
    if (!this.field) return

    this.field.focus()
    this.field.setSelectionRange(this.selectionStart, this.selectionEnd)
    this.field = null
  }
}
